
import { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { IconDotsVertical, IconPencil, IconCopy, IconDownload } from "@tabler/icons-react";
import {Link} from "react-router-dom";
import {copyToClipboard} from "../../../utils/functions";
import {toast} from "react-toastify";

export const ProjectRowMenu = ({project}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const onCopyExport = async (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (project.id) {
      try {
        const url = `${process.env.REACT_APP_FIREBASE_FUNCTIONS_URL}/api/apiProject/${project.id}`
        await copyToClipboard(url);
        toast.success("URL is copied successfully.")
      } catch (e) {
        console.log(e)
        toast.error("URL failed to copy.")
      }
    }

    handleClose(event);
  }

  const onExportFile = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    // Replace with the actual API endpoint that serves the file
    const apiUrl = `${process.env.REACT_APP_FIREBASE_FUNCTIONS_URL}/api/export/${project?.id}`;

    fetch(apiUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);

        // Create an anchor element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = `${project.id}.json`; // Specify the desired file name
        document.body.appendChild(a);
        a.click();

        // Clean up by removing the anchor and the URL
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading file: ', error);
      });

    handleClose(event);
  };


  return (
    <>
      <IconButton onClick={handleOpen}>
        <IconDotsVertical />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              p: 1, borderRadius: 3,
            }
          }
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleClose} component={Link} to={`/project/${project?.id}/settings`} sx={{borderRadius: 2, px: 2.5}}>
          <ListItemIcon><IconPencil size={18} /></ListItemIcon>
          <ListItemText>Edit Project</ListItemText>
        </MenuItem>
        <MenuItem onClick={onCopyExport} sx={{borderRadius: 2, px: 2.5}}>
          <ListItemIcon><IconCopy size={18} /></ListItemIcon>
          <ListItemText>Copy Export</ListItemText>
        </MenuItem>
        <MenuItem onClick={onExportFile} sx={{borderRadius: 2, px: 2.5}}>
          <ListItemIcon><IconDownload size={18} /></ListItemIcon>
          <ListItemText>Download Export</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
